var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as Long from "long";
import { TypeActionOutskirtsInfo } from "./actionOutskirtsInfo";
var initial = {
    outskirt: [],
    playerId: Long.ZERO,
    selectedOutskirtBuildingId: undefined,
};
export var reducerOutskirtsInfo = function (state, action) {
    if (state === void 0) { state = initial; }
    switch (action.type) {
        case TypeActionOutskirtsInfo.Received:
            return __assign({}, state, action.outskirtsInfo);
        case TypeActionOutskirtsInfo.Update:
            var foundUpdateInfoBuilding_1 = false;
            var outskirtWithUpdatedInfo = (state.outskirt || []).map(function (building) {
                if (building.typeId === action.info.typeId) {
                    foundUpdateInfoBuilding_1 = true;
                    return __assign({}, building, action.info);
                }
                return building;
            });
            if (!foundUpdateInfoBuilding_1) {
                outskirtWithUpdatedInfo.push(action.info);
            }
            return __assign({}, state, { outskirt: outskirtWithUpdatedInfo });
        case TypeActionOutskirtsInfo.UpdateStageInfo:
            var foundUpdateStageInfoBuilding_1 = false;
            var outskirtWithUpdatedStageInfo = (state.outskirt || []).map(function (building) {
                if (building.typeId === action.info.typeId) {
                    foundUpdateStageInfoBuilding_1 = true;
                    return __assign({}, building, { stage: action.info.stage });
                }
                return building;
            });
            if (!foundUpdateStageInfoBuilding_1) {
                outskirtWithUpdatedStageInfo.push(action.info);
            }
            return __assign({}, state, { outskirt: outskirtWithUpdatedStageInfo });
        case TypeActionOutskirtsInfo.UpdateImprovementInfo:
            var outskirts = state.outskirt;
            var foundOutskirtIndex = outskirts.findIndex(function (_a) {
                var typeId = _a.typeId;
                return typeId === action.id;
            });
            if (foundOutskirtIndex !== -1) {
                var foundOutskirt = outskirts[foundOutskirtIndex];
                var foundOutskirtImprovements = foundOutskirt.improvement || [];
                var foundImprovementIndex = foundOutskirtImprovements.findIndex(function (_a) {
                    var improvementId = _a.improvementId;
                    return improvementId === action.improvement.improvementId;
                });
                var newOutskirtImprovements = foundOutskirtImprovements.slice(0, foundImprovementIndex).concat([
                    __assign({}, foundOutskirtImprovements[foundImprovementIndex], action.improvement)
                ], foundOutskirtImprovements.slice(foundImprovementIndex + 1));
                outskirts[foundOutskirtIndex] = __assign({}, foundOutskirt, { improvement: newOutskirtImprovements });
                return __assign({}, state, { outskirt: outskirts });
            }
            return state;
        case TypeActionOutskirtsInfo.SelectOutskirtBuilding:
            return __assign({}, state, { selectedOutskirtBuildingId: action.buildingId });
        case TypeActionOutskirtsInfo.DeselectOutskirtBuilding:
            return __assign({}, state, { selectedOutskirtBuildingId: undefined });
    }
    return state;
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/outskirts/reducerOutskirtsInfo.ts
// module id = 2536
// module chunks = 3